import { createContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const AlertContext = createContext<{
  message: string | null;
  setMessage: (message: string | null) => void;
}>({
  message: null,
  setMessage: () => {},
});

export const AlertProvider = ({ children }: { children: React.ReactNode }) => {
  const [message, setMessage] = useState<string | null>(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const message = searchParams.get("message");
    if (message) {
      setMessage(message);
    }
  }, [searchParams]);

  return (
    <AlertContext.Provider value={{ message, setMessage }}>
      {children}
    </AlertContext.Provider>
  );
};

export default AlertContext;
